<div class="row-container">
  <!-- <button class="btn-header" *ngIf="isGuide" [routerLink]="['/dashboard']">{{'Dashboard' | translate }}</button> -->
  <div class="user-container">
    <div class="avatar-container">
      <img [src]="avatar" />
    </div>
    <div class="display-name">
      {{ user.displayName | slice:0:20}}
    </div>
    <span class="icon-container" id="dropdownMenuButton" data-testid="dropdown-menu-button" (click)="onDropdownToggle()" data-bs-toggle="dropdown"
      aria-haspopup="true" aria-expanded="false">
      <div [class]="menuIsVisible ? 'icon-img-up' : 'icon-img-down'"></div>
    </span>
    <div class="dropdown-menu dropdown-menu-right" id="menuDropdown" aria-labelledby="dropdownMenuButton">
      <button *ngIf="isGuide || isAdmin" data-testid="data-management-btn" id="btn-in-dropdown" class="dropdown-item" [routerLink]="['/dashboard']">
        {{'Data management' | translate }}</button>
      <button data-testid="user-management-btn" *ngIf="isGuide || isAdmin" id="btn-in-dropdown" class="dropdown-item" [routerLink]="['/admin/users']">
        {{'Users management' | translate }}</button>
      <button *ngIf="inVisit && inGuidedTourMission" id="btn-in-dropdown" class="dropdown-item" [routerLink]="['profile']"
        (click)="onProfileClick()">{{'Visitor Profile' | translate
        }}</button>
      <!-- <button class="dropdown-item" (click)="presentLanguageModal()">{{'Language' | translate}}</button> -->
      <div class="dropdown-divider"></div>
      <button class="dropdown-item support" (click)="openSupportForm()">{{'Help' | translate}}</button>
      <button data-testid="logout-auth-btn" class="dropdown-item signout" (click)="signOut()">{{'Logout' | translate}}</button>
    </div>
  </div>
</div>

<!-- Language Modal -->
<!-- <ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'We are available in 2 languages' | translate}}:</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="list-group list-group-flush">
      <a class="list-group-item list-group-item-action" (click)="onLangChange('fr')" [style.cursor]="'pointer'">🇫🇷
        Français</a>
      <a class="list-group-item list-group-item-action" (click)="onLangChange('en')" [style.cursor]="'pointer'">🇬🇧
        English</a>
    </div>
  </div>
</ng-template> -->